<!--  -->
<template>
  <div class="cell-container">
    <InformationRegistration ref="childComponent"
                             :childData="editUser" />
    <div class="delete-contact"
         v-if="$route.params.path == 'contactList' && editUser"
         @click="deleteUser()"><img src="../assets/delete.png"
           alt="delete">
      <div class="text">删除常用信息</div>
    </div>
    <div class="save-contact"
         @click="save">保存</div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import InformationRegistration from './InformationRegistration.vue'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: { InformationRegistration },
  data() {
    // 这里存放数据
    return {
      childData: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    deleteUser() {
      this.$dialog.confirm({
        title: '提示',
        message: '确认删除此常用信息？',
        confirmButtonColor: '#007aaa'
      })
        .then(() => {
          this.$http.get("/tempt/api/sjte/deleteUser", {
            params: {
              userId: this.editUser.id,
            },
          })
            .then((response) => {
              if (response.code && response.code !== 200) {
                console.error('业务错误：', response);
              } else {
                this.$toast({
                  message: '常用信息已删除',
                  duration: 800,
                });
                setTimeout(() => {
                  this.$router.push("/" + this.$route.params.path)
                }, 1000);

                // localStorage.setItem("addUserId", response.result.id)
              }
            }).catch((error) => {
              // 在这里处理错误
              console.error('请求出错：', error);
              // 可以根据实际情况添加更多错误处理逻辑，比如弹出提示框
              // 假设使用的是Element UI的Message组件来弹出错误提示
              this.$message.error('添加用户失败，请稍后再试');
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    save() {

      let addUserData = this.$refs.childComponent.addUserInfo
      const phoneRegex = /^1[0-9]{10}$/;
      if (addUserData.name == '') {
        this.$toast('请填写姓名');
      } else if (addUserData.phone == '') {
        this.$toast('请填写手机号');
      } else if (!phoneRegex.test(addUserData.phone)) {
        this.$toast('请填写正确的手机号');
      }
      // else if (addUserData.birthday == '' && this.meetingInfo?.name.includes("拜太岁")) {
      //   this.$toast('请选择阳历生日');
      // } else if (addUserData.times == '' && this.meetingInfo?.name.includes("拜太岁")) {
      //   this.$toast('请选择时辰');
      // }
      else {
        addUserData.isCreate = false
        if (this.$route.params.editUser) {
          this.$http.post("/tempt/api/sjte/updateUser", addUserData)
            .then((response) => {
              if (response.code && response.code !== 200) {
                console.error('业务错误：', response);
              } else {
                if (this.$route.params.editUser) {
                  this.$toast({
                    message: '常用信息已修改',
                    duration: 800,
                  });
                  setTimeout(() => {
                    this.$router.push({
                      name: this.$route.params.path,
                      params: {
                        selectedIndex: this.$route.params.selectedIndex,
                        name: this.$route.name,
                        editUser: this.editUser
                      },
                    })
                  }, 1000);

                } else {
                  this.$toast({
                    message: '常用信息已保存',
                    duration: 800,
                  });
                  setTimeout(() => {
                    this.$router.push("/" + this.$route.params.path)
                  }, 1000);
                }

                // localStorage.setItem("addUserId", response.result.id)
              }
            }).catch((error) => {
              // 在这里处理错误
              console.error('请求出错：', error);
              // 可以根据实际情况添加更多错误处理逻辑，比如弹出提示框
              // 假设使用的是Element UI的Message组件来弹出错误提示
              this.$message.error('添加用户失败，请稍后再试');
            });
        } else {
          addUserData.isCreate = true
          this.$http.post("/tempt/api/sjte/addUser", addUserData)
            .then((response) => {
              if (response.code && response.code !== 200) {
                console.error('业务错误：', response);
              } else {
                if (this.$route.params.editUser) {
                  this.$toast({
                    message: '常用信息已修改',
                    duration: 800,
                  });
                  setTimeout(() => {
                    this.$router.push({
                      name: this.$route.params.path,
                      params: {
                        selectedIndex: this.$route.params.selectedIndex,
                        name: this.$route.name,
                        editUser: this.editUser
                      },
                    })
                  }, 1000);

                } else {
                  this.$toast({
                    message: '常用信息已保存',
                    duration: 800,
                  });
                  setTimeout(() => {
                    this.$router.push("/" + this.$route.params.path)
                  }, 1000);
                }

                // localStorage.setItem("addUserId", response.result.id)
              }
            }).catch((error) => {
              // 在这里处理错误
              console.error('请求出错：', error);
              // 可以根据实际情况添加更多错误处理逻辑，比如弹出提示框
              // 假设使用的是Element UI的Message组件来弹出错误提示
              this.$message.error('添加用户失败，请稍后再试');
            });
        }

      }

    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.$route.params)
    this.editUser = this.$route.params.editUser ? this.$route.params.editUser : false
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.cell-container {
  height: 100vh;
  background-color: #f3f4f5;
  overflow: hidden;
}

.save-contact {
  background: linear-gradient(133deg, #007aaa, #004e93);
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  padding: 9px 0;
  margin: 24px 48px 0;
  text-align: center;
}

.delete-contact {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin: 16px 12px 0;
}

.delete-contact > img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.delete-contact .text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
}
</style>